import { useEffect, useState } from 'react';
import { configs } from '../configs';

// The sdm build environments are based on the settings-config.json file in bronx repo.
export enum CONFIG_ENVIRONMENT {
  DEVELOPMENT = 'development',
  PERF = 'perf',
  PRODUCTION = 'production',
  QA = 'qa',
  STAGING = 'staging',
  UAT = 'uat',
}

/**
 * The settings schema for view resolver.
 */
export interface IConfig {
  /**
   * The API key for the BFF.
   */
  apiKey: string;
  /**
   * The base URL for the BFF API.
   */
  sduiBaseUrl: string;
  /**
   * The base URL for the remotes entries of module federated components.
   */
  cdnBaseUrl: string;
  [k: string]: unknown;
}

/**
 * Hook to get the config for the current environment.
 */
export const useConfig = (env: CONFIG_ENVIRONMENT) => {
  const [config, setConfig] = useState<IConfig | null>(null);

  useEffect(() => {
    // Set the config state with the data from the config file.
    if (configs[env]) {
      setConfig(configs[env]);
    } else {
      // Log the error to the console if env is not valid.
      // eslint-disable-next-line no-console
      console.error(`Invalid environment: ${env}`);
    }
  }, [env]);

  if (!config && env) {
    setConfig(configs[env]);
  }

  return config;
};

export default useConfig;
